import { atom } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

/** Persisted Reflag user context override for the site-centric navigation opt-in. */
export const siteCentricOptInAtom = atom<'true' | 'false' | null>({
    key: 'siteCentricOptInAtom',
    default: null,
    effects: [localStorage.recoilEffect('@recoil/siteCentricOptInAtom', null)],
});
